module.exports = __webpack_public_path__ + "static/media/Footer Logo 1.af532132.png";